import { DEFAULT_EXCLUDE_FALSY_TOOGLE, DEFAULT_INCLUDE_TOTALS, DEFAULT_TAB_SPECIFIC_DATE, Query, TableOptions } from '@hub-components';

export class Table {
  constructor(
    public name,
    public readonly query: Query,
    public options: TableOptions = {
      dataOptions: {
        excludeFalsy: DEFAULT_EXCLUDE_FALSY_TOOGLE,
        includeTotals: DEFAULT_INCLUDE_TOTALS,
      },
      dateOptions: {
        interval: null,
        tabSpecificDate: DEFAULT_TAB_SPECIFIC_DATE,
      },
    },
  ) { }

  public asJson() {
    return {
      name: this.name,
      query: this.query.asJson(),
      options: this.options,
    };
  }
}
